export default "__VITE_PUBLIC_ASSET__4e127d66__"